import type { Brand } from '@seek/melways-sites';

import type { Customisations } from './modules/customisation/types';

export interface RenderContext {
  environment: string;
  html: string;
  meta: string;
  route: string;
  site: string;
  customisations: Customisations;
}

export type HandleSubmit<FormValues> = (
  handler: (formValues: FormValues) => void | Promise<any>,
) => (event: any) => void;

export interface ClientContext {
  site: string;
  route: string;
  environment: Environment;
  customisations: Customisations;
}

export interface FormProps<FormValues> {
  handleSubmit: HandleSubmit<FormValues>;
}

export type FormName =
  | 'email_lookup'
  | 'login'
  | 'register'
  | 'verification'
  | 'forgot_password'
  | 'reset_password'
  | 'activate_account'
  | 'expired_password';

export type PageName = 'login' | 'password_reset';

export type CaptchaEvent =
  | 'error_fetching_recaptcha'
  | 'error_loading_recaptcha_library'
  | 'error_rendering_recaptcha'
  | 'error_resetting_recaptcha'
  | 'recaptcha_fetched'
  | 'recaptcha_library_not_loaded'
  | 'recaptcha_loaded_but_reset_failed'
  | 'recaptcha_loaded_but_token_retrieve_failed'
  | 'recaptcha_reset'
  | 'success_loading_recaptcha_library_after_initial_failure';

export interface FormState<T extends string> {
  loading?: boolean;
  submitted?: boolean;
  error?: T;
}

export interface BotState {
  isBotCheckDone?: boolean;
  isRenderRecaptchaStarted?: boolean;
  isRenderRecaptchaDone?: boolean;
}

export interface EmailLookupResult {
  realmHint?: string;
}

export interface ApplyContext {
  title: string;
  advertiser: string;
}

export enum Experience {
  Hirer = 'hirer',
  Candidate = 'candidate',
  Business = 'business',
}

export type Environment = 'development' | 'staging' | 'production';

export interface ApiHeaderParams {
  locale: string;
  brand: Brand;
}

export interface FooterLink {
  name:
    | 'Privacy policy'
    | 'SEEK safely'
    | 'Security & Privacy'
    | 'Terms & Conditions'
    | 'Protect yourself online'
    | 'Contact'
    | '©Seek. All rights reserved.';
  href: string;
  rel: string;
  analytics: string;
  linkText: string;
  experience?: string;
}

export type SocialProvider = 'google' | 'facebook' | 'apple';

export type PasswordLessFormType = 'email' | 'verification';
